import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 9,
	viewBox: "0 0 8 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 1L4 9",
		stroke: "#AFAFAF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 4L4 1L7 4",
		stroke: "#AFAFAF"
	})]
});
export default SvgSortArrowUp;
